import { Alert, themeGet } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const StyledAlert = styled(Alert) `
  margin-bottom: ${themeGet('spacing.xl')};
`;
